import { render, staticRenderFns } from "./ds-empty-state.vue?vue&type=template&id=1fd003c7&scoped=true"
import script from "./ds-empty-state.vue?vue&type=script&lang=js"
export * from "./ds-empty-state.vue?vue&type=script&lang=js"
import style0 from "./ds-empty-state.vue?vue&type=style&index=0&id=1fd003c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd003c7",
  null
  
)

export default component.exports